<template>
  <div>
    <vapp-header btnClose btnContactBusinessOptions :contact_business_id="contactBeingEdited.id"></vapp-header>
    <div class="container pr-5 pb-5 pl-5 pt-2 d-flex flex-column">
      <div class="switch">
        <md-switch v-model="customer">Customer</md-switch>
        <md-switch v-model="supplier">Supplier</md-switch>
      </div>

      <form class="w-100 form-fnc" autocomplete="off">

        <div role="tablist" class="contact-accordion tablist-contact">

          <div class="border-bottom-10">
          </div>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-btn href="#" block v-b-toggle.businessinfo>
                <img src="@/assets/images/ct-user-solid.svg" />
                Business Info
                <img class="float-right" src="@/assets/images/angle-down-solid.svg" /></b-btn>
            </b-card-header>

            <b-collapse id="businessinfo" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <label>Business Name <span class="mandatory-remarks">*</span></label>
                <div class="input-group">
                  <img class="img-icon" src="@/assets/images/ct-icon-company.svg">
                  <input type="text" class="form-control" placeholder="e.g. Orange Sdn Bhd" v-model="business_name"
                        v-bind:class="{ 'is-invalid': attemptSubmit && missingBusinessName }">
                  <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'business_name'">{{ error.text }}</div>
                </div>

                <label>Company Registration No.</label>
                <div class="input-group">
                  <img class="img-icon-reg-no" src="@/assets/images/ic_company_register.svg">
                  <input type="text" class="form-control" placeholder="SSM Company Registration No." v-model="company_reg_no">
                </div>

                <label>Email</label>
                <div class="input-group">
                  <img class="img-icon-email" src="@/assets/images/ic_email.svg">
                  <input type="email" class="form-control" placeholder="hello@gmail.com.my" v-model="email"
                        v-bind:class="{ 'is-invalid': attemptSubmit && (missingEmail || invalidEmailFormat) }">
                  <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'email'">{{ error.text }}</div>
                </div>

                <label>Website URL</label>
                <div class="input-group">
                  <img class="img-icon" src="@/assets/images/ic_website.svg">
                  <input type="text" class="form-control" placeholder="www.website.com.my" v-model="website">
                </div>

                <label>Office Telephone Number</label>
                <div class="input-group">
                  <img class="img-icon" src="@/assets/images/ct-icon-telephone.svg">
                  <input type="number" class="form-control" placeholder="Please enter a valid number" v-model="office_telephone">
                </div>

                <!-- <label>Official Whatsapp Number</label>
                  <div class="input-group">
                    <img class="img-icon" src="@/assets/images/ct-icon-telephone.svg">
                    <div class="row">
                      <div class="col">
                        <select class="custom-select mr-sm-2 padding-override" v-model="whatsapp_number">
                          <option disabled value="">Select Income Category</option>
                        </select>
                      </div>

                      <div class="col">
                        <input type="text" class="form-control padding-override" placeholder="123456789">
                      </div>
                    </div>
                  </div> -->
              </b-card-body>
            </b-collapse>
          </b-card>

          <div class="border-bottom-10">
          </div>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-btn href="#" block v-b-toggle.contactperson>
                <img src="@/assets/images/ct-user-solid.svg" />
                Contact Person
                <img class="float-right" src="@/assets/images/angle-down-solid.svg" /></b-btn>
            </b-card-header>

            <b-collapse id="contactperson" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>

                <label>First Name</label>
                <div class="input-group">
                  <input type="text" class="form-control padding-override" placeholder="e.g. Dave" v-model="cp_first_name">
                </div>

                <label>Last Name</label>
                <div class="input-group">
                  <input type="text" class="form-control padding-override" placeholder="e.g. Bautista" v-model="cp_last_name">
                </div>

                <label>Display Name</label>
                <div class="input-group">
                  <input type="text" class="form-control padding-override" placeholder="e.g. Dave" v-model="cp_display_name">
                </div>

                <label>Email</label>
                <div class="input-group">
                  <input type="text" class="form-control padding-override" placeholder="e.g. Dave" v-model="cp_first_name" v-on:input="updateDisplayName">
                </div>

                <label>Mobile</label>
                <div class="input-group">
                  <input type="text" class="form-control padding-override" placeholder="e.g. Bautista" v-model="cp_last_name" v-on:input="updateDisplayName">
                </div>

              </b-card-body>
            </b-collapse>
          </b-card>

          <div class="border-bottom-10">
          </div>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-btn href="#" block v-b-toggle.address>
                <img src="@/assets/images/ct-icon-map.svg" />
                Address
                <img class="float-right" src="@/assets/images/angle-down-solid.svg" /></b-btn>
            </b-card-header>

            <b-collapse id="address" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <label>Street Address 1</label>
                <div class="input-group">
                  <input type="text" class="form-control padding-override" placeholder="e.g. No 8" v-model="street1">
                </div>

                <label>Street Address 2</label>
                <div class="input-group">
                  <input type="text" class="form-control padding-override" placeholder="e.g. Baker Street" v-model="street2">
                </div>

                <label>City</label>
                <div class="input-group">
                  <input type="text" class="form-control padding-override" placeholder="e.g. KD" v-model="city">
                </div>

                <label>State</label>
                <div class="input-group">
                  <input type="text" class="form-control padding-override" placeholder="e.g. Selangor" v-model="state">
                </div>

                <label>Postcode</label>
                <div class="input-group">
                  <input type="number" class="form-control padding-override" placeholder="e.g. 47810" v-model="postcode">
                </div>

                <label>Country</label>
                <div class="input-group">
                  <select class="custom-select mr-sm-2 padding-override" v-model="country">
                    <option disabled value="null">Select Country</option>
                    <option v-for="country in bCountries" :value="country.id" :key="country.id">{{ country.name }}</option>
                  </select>
                </div>

              </b-card-body>
            </b-collapse>
          </b-card>

          <div class="border-bottom-10">
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "EditBusiness",
  data() {
    return {
      // entity
      business_name: null,
      company_reg_no: null,
      email: null,
      website: null,
      office_telephone: null,
      customer: false,
      supplier: false,

      // contact person
      cp_display_name: null,
      cp_email: null,
      cp_first_name: null,
      cp_last_name: null,
      cp_phone: null,

      // address
      city: null,
      postcode: null,
      state: null,
      street1: null,
      street2: null,
      country: null,

      //Others
      attemptSubmit: false,
      errors: [],
      bCountries: [],
      currencies: null,
    }
  },
  computed: {
    ...mapState('contact', ['contactBeingEdited']),
    missingBusinessName: function () {
      if (!this.business_name) { return true; } else { return false; }
    },
    missingEmail: function () {
      if (!this.email) { return true; } else { return false; }
    },
    invalidEmailFormat: function () {
      if (!this.validEmail(this.email)) { return true; } else { return false; }
    },
    missingCPEmail: function () {
      if (!this.cp_email) { return true; } else { return false; }
    },
    invalidCPEmailFormat: function () {
      if (!this.validEmail(this.cp_email)) { return true; } else { return false; }
    },
    requestData: function() {
      return {
        is_customer: this.customer,
        is_supplier: this.supplier,
        memo: null,
        currency_id: this.getCurrencyId(this.country),
        method_id: null,
        term_id: null,
        files: [],
        supplier_currency_id: null,
        supplier_method_id: null,
        supplier_term_id: null,
        entity: {
          email: this.email,
          phone_no: this.office_telephone,
          name: this.business_name,
          reg_no: this.company_reg_no,
          website_url: this.website,
        },
        send_mail: true,
        contactpersons: [{
          display_name: this.cp_display_name,
          email: this.cp_email,
          phone_no: this.cp_phone,
          first_name: this.cp_first_name,
          last_name: this.cp_last_name,
        }],
        addresses: [{
          id: null,
          street: this.street1 + ' ' + this.street2,
          city: this.city,
          state: this.state,
          postcode: this.postcode,
          country_id: this.$store.state.user.country_id,
          is_primary: true,
          is_deleted: false,
        }],
        extras: [],
      }
    },
  },
  beforeDestroy () {
    this.$root.$off('attempt_submit_edit_business')
  },
  mounted() {
    console.log("Mounted : EditBusiness");
    // set customer data [PENDING FROM API]
    this.setContactData();
  
    // get countries list and currencies list
    this.axios
      .get("/pre_sign_up")
      .then(response => {
        this.$root.$emit('show-loading', false);
        this.currencies = response.data.currencies
        this.bCountries = response.data.countries

        for (var i = 0; i< this.bCountries.length; i++) {
          if (this.bCountries[i].code == 'MY') {
            this.country = this.bCountries[i].id
          }
        }
      }).catch(error => {
        this.$root.$emit('show-loading', false);
        this.$generalAPIErrorHandling(error, this.$router);
      });

    // Will get call when user click on done button top right
    // Do checking for compulsory fields first, then pop up confirmation dialog
    this.$root.$on('attempt_submit_edit_business', vars => {
      this.errors = [];
      this.attemptSubmit = true;

      if (this.missingBusinessName) {
        this.errors.push({id: 'business_name', text: "This field is compulsory"});
      }

      if (this.missingEmail) {
        this.errors.push({id: 'email', text: "This field is compulsory"});
      }
      else if (this.invalidEmailFormat) {
        this.errors.push({id: 'email', text: 'Valid email required.'});
      }

      if (!this.missingCPEmail && this.invalidCPEmailFormat) {
        this.errors.push({id: 'cpemail', text: 'Valid email required.'});
      }

      if(!this.errors.length) {
        event.preventDefault();
        this.$confirmationToast("Edit Business?", "Are you sure you want to edit this business?", this.editBusiness, null);
      } else {
        event.preventDefault();
      }
    })
  },
  methods: {
    setContactData () {
      let contact = this.contactBeingEdited;

      this.contactpersons = contact.contactpersons.length;

      //entity data
      this.business_name = contact.entity.display_name;
      this.company_reg_no = contact.entity.reg_no;
      this.email = contact.entity.email;
      this.website = contact.entity.website_url;
      this.office_telephone = contact.entity.phone_no;
      this.supplier = contact.is_supplier;
      this.customer = contact.is_customer;

      //contact person data
      if(this.contactpersons){
        this.cp_display_name = contact.contactpersons[0].people.display_name;
        this.cp_email = contact.contactpersons[0].people.email;
        this.cp_first_name = contact.contactpersons[0].people.first_name;
        this.cp_last_name = contact.contactpersons[0].people.last_name;
        this.cp_phone = contact.contactpersons[0].people.phone_no;
      }

      //address data
      if(contact.addresses.length){
        this.city = contact.addresses[0].city;
        this.postcode = contact.addresses[0].postcode;
        this.state = contact.addresses[0].state;
        this.street = contact.addresses[0].street;
        this.country = contact.addresses[0].country_name;
      }

      // future to diplay multiple contact name
  },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    getCurrencyId: function(country_id) {
      for(var i = 0; i<this.currencies.length; i++) {
        if(this.currencies[i].country_id == country_id) {
          let currency_id = this.currencies[i].id
          return currency_id
        }
      }
    },
    goBack() {
      window.history.length > 1 ?
              this.$router.go(-1) :
              this.$router.push('/login')
    },
    editBusiness() {
      this.$root.$emit('show-loading', true);
      this.axios({
        method: 'put',
        url: '/contacts/companies/' + this.contactBeingEdited.id,
        data: this.requestData,
      }).then(response => {
        this.$root.$emit('show-loading', false);
        this.goBack()
        /*this.$router.go(-1)*/
      }).catch(error => {
        this.$root.$emit('show-loading', false);
        this.$generalAPIErrorHandling(error, this.$router);
      })
    },
    updateDisplayName() {
        this.cp_display_name = this.cp_first_name + " " + this.cp_last_name;
    }
  },
}
</script>
